export const emailRegExp = new RegExp(
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
    "i",
);
export default {
    email: function (value) {
        return value && typeof value === "string" && value.match(emailRegExp);
    },
    objectId: function (value) {
        return value.match(/^[a-f0-9]{24}$/);
    },
};
